import React from "react";

// plugin imports
import { Trans, useI18next } from "@herob191/gatsby-plugin-react-i18next";
import { motion } from "motion/react";

// style imports
import "./restaurantsAccordion.scss";

// component imports

// util imports
import useRestaurants from "../../utils/restaurantsQuery";

// svg imports
import IconPlus from "../../svg/icon/iconPlus.svg";

function CityRestaurantsAccordion({
	location,
	restaurants,
	component,
	forceOpen,
}) {
	const { language } = useI18next();

	const contentRef = React.useRef();
	const [expanded, setExpanded] = React.useState(forceOpen || false);

	const city = location || "";
	const cityRestaurants = restaurants.filter(
		(restaurant) => restaurant.frontmatter.location[language] === location,
	);

	// if (showIfOnlyOne && cityRestaurants.length === 1) {
	// 	return (
	// 		<div className="cityRestaurantsAccordion">
	// 			<div className="cityRestaurantsContent">
	// 				<div>
	// 					{component({
	// 						restaurant: cityRestaurants[0],
	// 						onlyRestaurant: true,
	// 					})}
	// 				</div>
	// 			</div>
	// 		</div>
	// 	);
	// }
	return (
		<div className="cityRestaurantsAccordion">
			<button onClick={() => setExpanded(!expanded)} disabled={forceOpen}>
				<span className={`h2 padding ${forceOpen ? "small" : ""}`}>
					<Trans>Locales {{ city }}</Trans>
				</span>
				{!forceOpen && (
					<motion.div animate={{ rotate: expanded ? 45 : 0 }}>
						<IconPlus />
					</motion.div>
				)}
			</button>

			<motion.div
				initial={{ height: 0 }}
				animate={{ height: expanded ? "auto" : 0 }}
				className="cityRestaurantsContent"
				ref={contentRef}
			>
				{cityRestaurants.map((restaurant, i) => (
					<div key={location + "restaurant" + i}>
						{component({ restaurant })}
					</div>
				))}
			</motion.div>
		</div>
	);
}

export default function RestaurantsAccordion({ component, forceOpen = false }) {
	const { language } = useI18next();
	const restaurants = useRestaurants(
		(restaurant) => !restaurant.frontmatter.comingSoon,
	);
	const locations = [
		...new Set(
			restaurants.map(
				(restaurant) => restaurant.frontmatter.location[language],
			),
		),
	];

	return (
		<div className="restaurantsAccordion">
			{locations.map((location) => (
				<CityRestaurantsAccordion
					key={location}
					location={location}
					restaurants={restaurants}
					component={component}
					forceOpen={forceOpen}
				/>
			))}
		</div>
	);
}
